export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f8f42741311e626169f74409d44466844987852af&name=fetchTypeahead!'